import React from 'react';
import { ListItemText, TextField } from '@mui/material';
import { TallyCompany } from '../../../../../types/tally';

interface CompanyDetailsProps {
  company: TallyCompany;
  onGstChange: (companyName: string, value: string) => void;
}

const CompanyDetails: React.FC<CompanyDetailsProps> = ({
  company,
  onGstChange,
}) => {
  return (
    <ListItemText
      primary={company.name}
      secondary={
        company.isEditingGst ? (
          <TextField
            value={company.editedGstNumber || ''}
            onChange={e => onGstChange(company.name, e.target.value)}
            size="small"
            sx={{ width: { xs: '100%', sm: '200px' } }}
          />
        ) : (
          `GST: ${company.gstNumber === null ? 'N/A' : company.gstNumber}`
        )
      }
    />
  );
};

export default CompanyDetails;
